import noop from "../lib/core/functional/noop";
import loadExternalStylesheet from "../utils/loadExternalStylesheet";

import callIfArgumentsPass from "../utils/callIfArgumentsPass";
import thunk from "../lib/core/functional/thunk";

const loggedInModules = {
    showbtests: (moduleValue) =>
        import("./showBTests").then((module) => module.default(moduleValue)),
};

const loggedOutModules = {
    stickybtest: (moduleValue) =>
        import("./stickyBTests").then((module) => module.default(moduleValue)),
    serversidetimings: (moduleValue) =>
        import("./serversidetimings").then((module) => module.default(moduleValue)),
    showcomponents: (moduleValue) =>
        import("./addBrickHyperLinks").then((module) => module.default(moduleValue)),
    cwvchecklist: (moduleValue) =>
        import("./cwvChecklist/index").then((module) => module.default(moduleValue)),
};

function moduleLoaderReducer(moduleDict, requestedModule) {
    const [moduleName, moduleValue] = requestedModule.split(":");
    if (moduleName in moduleDict) {
        moduleDict[moduleName](moduleValue);
    }
    return moduleDict;
}

function loadModules(requested, moduleDict) {
    requested.reduce(moduleLoaderReducer, { ...moduleDict });
}

function didUserInfoChanged(prevErr, prevUser, err, user) {
    if (prevErr != err) {
        return true;
    }

    return user.profileSite.id !== prevUser.profileSite.id;
}

loadExternalStylesheet("/static/css-build/roar/runner/components/lddebugger.css", noop);

export default function ldDebugger(context, requestedModules) {
    loadModules(requestedModules, loggedOutModules);
    context.listenForUserInfo(
        callIfArgumentsPass(
            didUserInfoChanged,
            thunk(loadModules)(requestedModules, loggedInModules)
        )
    );
}
